<template>
  <div>
    <top-bar/>
    <div class="w3-main" style="margin: 50px 0 50px 300px;">
      <header class="w3-container" style="padding-top:24px">
        <div><i class="fa fa-wikipedia-w"></i> <b>Wiki LeCard</b></div>
      </header>
      <div class="w3-padding">
        <div class="w3-cell-row primary acordion-header" @click="abrirAcordion(1)">
          <div class="w3-cell">
            <i class="fa fa-cart-arrow-down fa-fw"></i>
            &nbsp;<span class="w3-small"><b>PDV</b></span>
          </div>
          <div class="w3-cell w3-right-align" style="width: 40px">
            <i class="fa" :class="acordion === 1 ? 'fa-chevron-up' : 'fa-chevron-down'"></i>
          </div>
        </div>
        <wiki-pdv :aberto="acordion === 1"/>
        <div class="w3-cell-row primary acordion-header" @click="abrirAcordion(2)">
          <div class="w3-cell">
            <i class="fa fa-cart-arrow-down fa-fw"></i>
            &nbsp;<span class="w3-small"><b>Caixas</b></span>
          </div>
          <div class="w3-cell w3-right-align" style="width: 40px">
            <i class="fa" :class="acordion === 2 ? 'fa-chevron-up' : 'fa-chevron-down'"></i>
          </div>
        </div>
        <wiki-caixa :aberto="acordion === 2"/>
      </div>
    </div>
  </div>
</template>

<script>
  import TopBar from "../commons/TopBar.vue"
  import WikiPdv from "./acordion/WikiPdv"
  import WikiCaixa from "./acordion/WikiCaixa"

  export default {
    components: {TopBar, WikiPdv, WikiCaixa},
    data() {
      return {
        acordion: 1,
        acordionPdv: true,
        acordionCaixa: false,
      }
    },
    methods: {
      abrirAcordion(acordion) {
        this.acordion === acordion ? this.acordion = 0 : this.acordion = acordion
      }
    }
  }
</script>

<style>
  .acordion-header {
    padding: 12px 16px;
    cursor: pointer;
    margin-top: 6px;
    border-radius: 2px;
  }
  .acordion {
    border-bottom: 1px solid #ccc;
    padding: 12px 16px;
    cursor: pointer;
  }
  .acordion:last-child {
    border-bottom: none;
  }
</style>



// WEBPACK FOOTER //
// src/components/wiki/WikiDash.vue